// extracted by mini-css-extract-plugin
export default {"wrapper":"_608500ff","title":"_a613034c","header":"_274dea93","isSwiperCarousel":"_4e5847ac"};